import { MobileTabsMenu } from './MobileTabsMenu'
export default MobileTabsMenu
